import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import styled, { DefaultTheme, StyledComponent } from "styled-components";
import { JSXElement } from "@babel/types";
import { useBreakpoint } from "styled-breakpoints/react-styled";
import { Link, VStack, Heading } from "@chakra-ui/react";
import { EmailIcon, PhoneIcon } from "@chakra-ui/icons";

import FlexDisplay from "../../../atoms/FlexDisplay";
import FlexDisplayItem from "../../../atoms/FlexDisplayItem";
import { ITeamMemberFields } from "src/types/generated/contentful";
//import Button from "../../Button";
import NextLink from "next/link";
import { between, down } from "styled-breakpoints";
import theme from "src/styles/theme";
import { formatPhoneNumber } from "./CardLayout";
import ImageTopic from "src/components/atoms/ImageTopic";

const CellWrapper = styled.div`
  padding: 1em;
`;

type TeamMemberProps = { "data-layoutid"?: string } & ITeamMemberFields;

const BobLayout = (data: TeamMemberProps): JSX.Element => {
  //console.log("TeamMember", JSON.stringify(data));

  const isMobile = useBreakpoint(down("sm"));
  const isTablet = useBreakpoint(between("sm", "lg"));

  const {
    email,
    name,
    nickName,
    slug,
    accreditationImage,
    bio,
    jobTitle,
    licenseNumbers,
    nationalProducerNumber,
    phone,
    images,
  } = data;

  // if L then return the whole page, else return the small card
  return (
    <StylingWrapper>
      <FlexDisplay
        direction={isMobile || isTablet ? "Column" : "Row"}
        content={[]}
        title={""}
        flexDisplayHorizontalAlignment={"Left"}
        flexDisplayVerticalAlignment={"Top"}
      >
        <ImageTopic
          image={images}
          flexDisplayHorizontalAlignment="center"
          flexDisplayVerticalAlignment="top"
          width={500}
          height={500}
          style={{ padding: 0 }}
          radius={"1em"}
        />
        <TextColumn
          fv="space-between"
          fh={isMobile || isTablet ? "center" : "left"}
        >
          <TextWrapper>
            <Heading
              as={"h2"}
              size={"xl"}
              paddingTop={isMobile || isTablet ? "1em" : "0"}
            >
              {`${name} aka "${nickName}"`}
            </Heading>
            <Heading as={"h3"} size={"md"}>
              {jobTitle}
            </Heading>
          </TextWrapper>

          <VStack alignItems="flex-start">
            {/*} <Button
              style={{
                color: theme.palette.common.darkBlue,
                marginBottom: 15,
              }}
              variant="Link"
              iconPlacement="Left"
              iconVariant="fa-solid fa-envelope"
              url={`mailto:${email}`}
            >
              {email}
            </Button>*/}
            <Link mt={4} color="brandAccent.500" href={`mailto:${email}`}>
              <EmailIcon /> {email}
            </Link>
            {/*<Button
              variant="Link"
              iconPlacement="Left"
              iconVariant="fa-solid fa-phone"
              url={`tel:${phone}`}
              style={{
                color: theme.palette.common.darkBlue,
              }}
            >
              {formatPhoneNumber(phone?.toString() || "")}
            </Button>*/}

            <Link color="brandAccent.500" href={`tel:${phone}`}>
              <PhoneIcon /> {` ${formatPhoneNumber(phone?.toString() || "")}`}
            </Link>
          </VStack>
          {/*<Button
            variant="Link"
            themeName="Contained"
            url={`/team-member/${slug}`}
          >{`Read Robert's Bio`}</Button>*/}
          <Link
            mt={20}
            as={NextLink}
            variant="brand-solid-accent"
            href={`/team-member/${slug}`}
          >
            {`Read Robert's Bio`}
          </Link>
        </TextColumn>
      </FlexDisplay>
    </StylingWrapper>
  );
};

const TextWrapper = styled.div`
  ${down("lg")} {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    h1 {
      text-align: center !important;
    }
  }
`;

const getSplit = (isMobile: boolean | null, isTablet: boolean): number => {
  if (isMobile) {
    return 1;
  } else if (isTablet) {
    return 2;
  }
  return 3;
};

const TextColumn = styled(FlexDisplayItem)`
  margin: 2em 0;

  ${down("lg")} {
    margin: 0;
  }
`;

const StylingWrapperCard = styled(FlexDisplayItem)`
  h2 {
    font-size: calc(${({ theme }) => theme.typography.h2.fontSize}rem - 2.5rem);
    padding: 0;
    margin: 0;
  }

  a {
    font-size: 0.6rem;
  }
`;

const StylingWrapper = styled.section``;

/*
const StyledButton = styled(Button)`
  color: #a8a8a8;
  margin: 2em;
  a {
    color: #a8a8a8;
    font-size: 1rem;
    text-decoration-color: rgba(0, 0, 0, 0.3);
  }
`;
*/
const FlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1em;
`;

const CenterItems = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 1em;
  h2 {
    width: 60%;
  }
`;

const LicenseTable = styled.table`
  width: ${(props) => props.width || "100%"};
  border-collapse: collapse;

  th,
  td {
    padding: 1em;
  }
  thead tr {
    th {
      background-color: ${(props) =>
        props.theme.palette.common.darkBlue} !important;
      color: #fff;
    }
  }
  tr:nth-child(even) {
    background: #f2f2f2;
  }
  tr:nth-child(odd) {
    background: #fff;
  }
`;

export default React.memo(BobLayout);
